require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019.json") })
        }
      }, "path---relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019!./.cache/json/relazioni-e-conferenze-ilaria-giannetti-the-n-2-chiasso-san-gottardo-motorway-the-design-and-construction-of-143-km-of-concrete-zurigo-26-gennaio-2019.json
// module id = 701
// module chunks = 231608221292675